export default "__VITE_ASSET__Dxp6lQHm__"